import * as React from 'react';

import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { Link, Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout.tsx';
import Tab from 'src/components/navigation/Tab.tsx';
import TabRow from 'src/components/navigation/TabRow.tsx';
import { RESERVATION_TYPE } from 'src/features/reservations/types/reservationType.ts';
import { reservationMessages } from 'src/features/reservations/utils/messages.ts';
import { Button } from 'src/registry/ui/Button.tsx';
import { useTitleStore } from 'src/stores/useTitleStore.ts';

const ReservationsLayout = () => {
    const { parkingId } = useParams();
    const { reservationType } = useParams();
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        if (!reservationType) return;
        setTitle(formatMessage(reservationMessages[reservationType as RESERVATION_TYPE]));
        return () => removeTitle();
    }, [reservationType, formatMessage]);

    return (
        <>
            <TabRow>
                <Tab end to={`/parking-management/${parkingId}/reservations/${reservationType}`}>
                    {formatMessage(reservationMessages.details)}
                </Tab>
                <Tab to={`/parking-management/${parkingId}/reservations/${reservationType}/versions`}>
                    {formatMessage(reservationMessages.versions)}
                </Tab>
            </TabRow>

            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to={`/parking-management/${parkingId}/reservations`}>
                    <FontAwesomeIcon icon={faChevronLeft} className="opacity-50" />
                    {formatMessage(reservationMessages.backReservations)}
                </Link>
            </Button>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
};

export default ReservationsLayout;
